import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface ErrorAlertProps {
  message: string;
  show?: boolean;
  className?: string;
  onDismiss?: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  show = true,
  className = "",
  onDismiss,
}) => {
  if (!show) return null;

  return (
    <div className={`alert alert-danger ${s.errorMessage} ${className}`}>
      {message}
      {onDismiss && (
        <button
          type="button"
          className="btn-close"
          onClick={onDismiss}
          aria-label="Close"
        />
      )}
    </div>
  );
};

export default withStyles(s)(ErrorAlert);